import React, { useState, useEffect } from "react";
import { Box, Button, Typography, TextareaAutosize, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Select, MenuItem, FormControl, FormLabel } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from "react-redux";
import { addEmailTemplate, updateEmailTemplate, fetchEmailTemplatesById } from "../../redux/Slice/emailTemplate"; 
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { setLoading } from "../../redux/Slice/loaderSlice";
import RunCodeEditor from "../../components/codeditor/CodeEditor";

const EmailEditor = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();  
  
  const isEditing = state?.name === "edit";
  const [template, setTemplate] = useState({ name: "", code: "", platform: "" });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newTag, setNewTag] = useState("");
  const [addingNew, setAddingNew] = useState(false);
  const [templateNameError, setTemplateNameError] = useState(false);
  const [tagError, setTagError] = useState(false);

  const dispatch = useDispatch();
  const message = useSelector((state) => state.message);

  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);

 

  useEffect(() => {
    if (isEditing && id) {
      dispatch(setLoading(true));
      dispatch(fetchEmailTemplatesById(id))
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
    }
  }, [dispatch, isEditing, id]);

  const {selectedTemplate} = useSelector((state) => state.email); 
  // console.log("sel",selectedTemplate)


  useEffect(() => {
    if (isEditing && selectedTemplate) {
      setTemplate({
        _id:selectedTemplate?._id,
        name:selectedTemplate?.name,
        code: selectedTemplate?.codeContent, 
        // status:selectedTemplate?.status,
        platform:selectedTemplate?.platform,
      });

    }
    // console.log("dd",template)


  }, [selectedTemplate, isEditing]);

  // useEffect(() => {
  //   const fetchHtmlFromUrl = async () => {
  //     try {
  //       const response = await fetch(selectedTemplate?.code);
  //       if (response.ok) {
  //         const html = await response.text();
  //         console.log("res",html)
  //         setTemplate((prev) => ({ ...prev, code: html }));
  //       } else {
  //         console.error("Failed to fetch HTML content");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching HTML:", error);
  //     }
  //   };

  //   fetchHtmlFromUrl();
  // }, [selectedTemplate.code]);
  
  
   
  
  useEffect(() => {
    const iframe = document.getElementById("myframe").contentWindow.document;
    iframe.open();
    iframe.write(template.code);
    iframe.close();
  }, [template.code]);

  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => {
    setDialogOpen(false);
    setAddingNew(false);
    setTemplateNameError(false);
    setTagError(false);
  };

  

  const handleSave = async () => {
    dispatch(setLoading(true));
    
    // Check for validation errors
    if (!template.name.trim()) {
      setTemplateNameError(true);
    } else {
      setTemplateNameError(false);
    }
  
    
  
    if (template.name.trim()) {
      if (isEditing) {
        // Ensure template._id is valid
        if (template._id) {
          dispatch(updateEmailTemplate({ id: template._id, formData: template }))
          .then(()=>{
            dispatch(setLoading(false));
            navigate("/email");
          })
        } else {
          console.error('Template ID is missing');
        }
      } else {
        // Add new template
        dispatch(addEmailTemplate(template))
        .then(()=>{
          dispatch(setLoading(false));
          navigate("/email");
        })
      }
      handleDialogClose();
    }
  };
  
  

  //  useEffect(()=>{
  //     if(state?.name === "Edit"){
  //     setTemplate({...selectedTemplate});
  //     }
  //   }, [selectedTemplate, state])
  

  return (
    <div className="content">
      <Box sx={{ padding: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems:'center', mb: 2}}>
          <Typography variant="h4">{isEditing ? "Edit Template" : "Add Template"}</Typography>
          <Button
            variant="contained"
            color="success"
            sx={{
              display: "flex",
              alignItems: "center",
              "&:hover": { backgroundColor: "#2FB354" },
            }}
            onClick={handleDialogOpen}
          >
            Save
          </Button>
        </Box>

        <Box >
        <Grid container spacing={2}>
        <Grid size={6}>
        <RunCodeEditor
         template={template}
         setTemplate={setTemplate}/>
        </Grid>
        <Grid size={6}>
        <iframe
            id="myframe"
            title="HTML Preview"
            style={{
              width: "100%",
              height: "500px",
              border: "1px solid #333",
              overflow: "auto",
              borderRadius: "10px",
            }}
          />
        </Grid>
        </Grid>
          {/* <textarea
            placeholder="Type HTML Code Here"
            minRows={10}
            style={{
              width: "100%",
              border: "1px solid #333",
              padding: "8px",
              height: "480px",
              overflow: "auto",
              borderRadius: "10px",
            }}
            value={template.code}
            onChange={(e) => setTemplate({ ...template, code: e.target.value })}
          /> */}
        </Box>
      </Box>

      <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth>
        <DialogTitle>{isEditing ? "Edit Template" : "Save Template"}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal">
            <FormLabel>Template Name</FormLabel>
            <TextField value={template.name} onChange={(e) => setTemplate({ ...template, name: e.target.value })} placeholder="Enter template name" />
            {templateNameError && <Typography color="error">Template name is required</Typography>}
          </FormControl>

          <Select
  value={template.platform || ""}
  onChange={(e) => setTemplate({ ...template, platform: e.target.value })}
  fullWidth
>
  <MenuItem value="" disabled>
    Select a Platform
  </MenuItem>
  <MenuItem value="Admin">Admin</MenuItem>
  <MenuItem value="Customer">Customer</MenuItem>
</Select>


          {/* <FormControl fullWidth margin="normal">
            <FormLabel>Tag</FormLabel>
            {addingNew ? (
              <Box display="flex" gap={2}>
                <TextField value={newTag} onChange={(e) => setNewTag(e.target.value)} placeholder="Enter new tag" fullWidth />
                <Button variant="contained" color="success" sx={{ "&:hover": { backgroundColor: "#2FB354" } }} onClick={handleAddNewTag}>
                  Add
                </Button>
              </Box>
            ) : (
              <Select
                value={template.tag || ""}
                onChange={(e) => setTemplate({ ...template, tag: e.target.value })}
                fullWidth
              >
                <MenuItem value="" disabled>
                  Select a tag
                </MenuItem>
                {tags?.filter((item) => item && item._id).map((item, index) => (
                  <MenuItem key={index} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
                <MenuItem value="createNew" onClick={() => setAddingNew(true)}>
                  + Create New
                </MenuItem>
              </Select>
            )}
            {tagError && <Typography color="error">Tag is required</Typography>}
          </FormControl> */}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="error">
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSave} sx={{ "&:hover": { backgroundColor: "#2FB354" } }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default EmailEditor;
